import { useEffect, useState, useContext } from 'react';
import { IconButton, Box, Typography } from '@mui/material';
import { ModeContext } from './ModeContext';
import ControlPoint from '@mui/icons-material/ControlPoint';
import { LoadToCosmos } from './SendToCosmos';
import FileDetailModal from './FileDetailModal';
import QuizIcon from '@mui/icons-material/Quiz';
import FileDetailModalFaq from './FileDetailModalFaq';

  const SidebarFilelist = () => {
  const [modalType, setModalType] = useState(null);

  const { fileList, setFileList,
    selectedFile, setSelectedFile,
    loginInfo
   } = useContext(ModeContext);

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isFaqModalOpen, setIsFaqModalOpen] = useState(false);

  // ファイルリストをCosmosから読み込み（Display画面用にfileListを更新）
  const loadFilesFromCosmos = async () => {
    try {
      const grouped = {};
      const uppayload = { 
        id: 'bu',
        bu:loginInfo.compId,
        container: 'con-concierge-file',
      };
      const res = await LoadToCosmos(uppayload);

      if (res?.item && Array.isArray(res.item)) {
        res.item
          .filter((doc) => doc.bu === loginInfo.compId && doc.status !== 'delete')
          .filter((doc) => {
            // filter2が「自分のみ」のドキュメントは登録者本人(filter4)のみ表示
            if (doc.filter2 === 'MY_ONLY') {
              const ownerUserId = doc.filter4;
              const currentUserId = loginInfo.userId;
              console.log('[SidebarFilelist MY_ONLY判定]', { docId: doc.filter4, filter4: ownerUserId, loginUserId: currentUserId, match: ownerUserId === currentUserId, docKeys: Object.keys(doc) });
              return ownerUserId === currentUserId;
            }
            return true;
          })
          .forEach((doc) => {
            const category = doc.category || '未分類';
            if (!grouped[category]) grouped[category] = [];
            grouped[category].push({
              id: doc.id,
              title: doc.filename,
              url: doc.url,
              messages: { category },
              raw: doc,
            });
          });
      }
      console.log('[SidebarFilelist] grouped結果:', JSON.stringify(Object.keys(grouped)), '件数:', Object.values(grouped).flat().length);
      setFileList(grouped);
    } catch (err) {
      console.error('Cosmosファイル取得エラー:', err);
    }
  };

  useEffect(() => {
    if (loginInfo?.compId) {
      loadFilesFromCosmos();
    }
  }, [loginInfo]);

  return (
    <Box>
      {/* ファイル追加ボタン */}
      <IconButton onClick={() => {
        setSelectedFile(null);
        setModalType("new");
        setIsDetailModalOpen(true);
        }}>
        <span style={{ fontSize: '11px' }}>ファイル追加</span>
        <ControlPoint />
      </IconButton>

      <hr style={{ border: '1px solid #ccc', marginTop: '5px', marginBottom: '5px' }} />

      {/* FAQ登録ボタン */}
      <IconButton onClick={() => setIsFaqModalOpen(true)}>
        <span style={{ fontSize: '11px' }}>FAQ登録</span>
        <QuizIcon sx={{ ml: 0.5 }} />
      </IconButton>

      <hr style={{ border: '1px solid #ccc', marginTop: '5px', marginBottom: '10px' }} />

      <Typography variant="body2" component="span" sx={{ px: 2, py: 1, color: '#666' }}>
        ここで取り込まれた情報は、<img src="/images/faqdoc.png" alt="faqdoc" style={{ width: 20, height: 20, verticalAlign: 'middle' }} />が回答します。
      </Typography>

      {/* ファイル追加モーダル */}
      <FileDetailModal
        open={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        fileData={selectedFile}
        type={modalType}
        onUpdated={loadFilesFromCosmos}
      />

      {/* FAQ登録モーダル */}
      <FileDetailModalFaq
        open={isFaqModalOpen}
        onClose={() => setIsFaqModalOpen(false)}
        faqData={null}
        type="new"
        onUpdated={loadFilesFromCosmos}
      />
    </Box>
  );
};

export default SidebarFilelist;
